import { render, staticRenderFns } from "./messageInform.vue?vue&type=template&id=1ca3061c&scoped=true&"
import script from "./messageInform.vue?vue&type=script&lang=js&"
export * from "./messageInform.vue?vue&type=script&lang=js&"
import style0 from "./messageInform.vue?vue&type=style&index=0&id=1ca3061c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca3061c",
  null
  
)

export default component.exports